import { createFileRoute } from '@tanstack/react-router';

import { NewEventPage } from '../modules/events/ui/pages/NewEventPage';

export const Route = createFileRoute('/_authenticated/dashboard/events/new')({
  component: NewEventPage,
  staticData: {
    breadcrumb: ['Manage', 'Events', 'New'],
  },
});
